import React, { useEffect, useRef, useState } from "react";
import { useSnackbar } from "notistack";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
 
} from "reactstrap";

import API from "../../../redux/actions/API";
import {
  DOG_LICENSE_DETAILS,
  UPDATE_LICENSE_STATUS,
  REFUND_PAYMENT,
} from "../../../constants/ApiPaths";

import CustomPageLoading from "../../CustomComponents/CustomPageLoading";
import Swal from "sweetalert2";

import { CustomAlertMessage } from "../../../functions/CustomFunctions";
import {  JSONParser } from "../../../functions/Helper";
import AgencyPreviewform from "../../Agency/Customer/AgencyPreviewform";
import moment from "moment";
import ReuploadFormValue from "../../User/License/ReuploadFormValue";
import { useSelector } from "react-redux";
import logo from "../../../images/logo.png";
import jsPDF from "jspdf";
import html2pdf from "html2pdf.js";
// const initailValue = {
//   validFromDate: "",
//   validToDate: "",
//   dogLicenseNumber: "",
// };
export default function PreviewDetails(props) {
  const {
    licensePlanId,
    dogLicenseId,
    setDogLicenseId,
    licenseDetails,
    setlicenseDetails,
    currentStep,
    setDocumentUrl,
    moreflag,
  } = props;
  console.log(licenseDetails, "licese");
  // const [licenseDetails, setlicenseDetails] = useState({});
  const pdfRef = useRef(null);
  // const [reqNu, setreqNu] = useState(true);
  // const [Reupload, setReupload] = useState(initailValue);
  const [loading, setloading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  // const [DeleverSpinner, setDeleverSpinner] = useState(false);
  const [isEditable, setisEditable] = useState(true);
  const DeleteAgency = useSelector((state) => state.Agencydelete);

  const {
    licensePlanDetails,
    categoryDetails,
    licenseStatus,
    paymentDetails,
    licenseRequiredDocDetails,
    dogId,
  } = licenseDetails;
  const paymentData = JSONParser(paymentDetails, []);
  const paymaentid = paymentData[0];
  const licensePlanData = JSONParser(licensePlanDetails, []);
  const categoryData = JSONParser(categoryDetails, []);
  const document = JSONParser(licenseRequiredDocDetails, []);
  
  // const Datetoggle = () => {
  //   setreqNu(true);
  //   setModal(!modal);
  // };
  useEffect(() => {
    if (moreflag) {
      setDogLicenseId("");
      setlicenseDetails({});
    }
  }, [moreflag, currentStep]);
  const Answer = categoryData.map((ans) => JSONParser(ans.categoryAnswer, []));
  let csvHeaders = [];
  let csvAnswer = {};
  const { planName } = licensePlanData[0] || {};
  Answer.forEach((A) => {
    A.categoryPlaceHolder.forEach((field) => {
      csvHeaders.push({ label: field?.label, key: field.uniqueId });
      if (["select", "checkbox", "radio"].includes(field.type)) {
        let fieldValueAnswer = field.selectedAnswer;
        if (field.type === "checkbox") {
          let CheckboxAnswer = [];
          field.options.forEach((option) => {
            if (fieldValueAnswer.includes(option.value)) {
              CheckboxAnswer.push(option.value);
            }
          });
          fieldValueAnswer = CheckboxAnswer.join(",");
        } else {
          let fieldValue = field.options.find(
            (o) => o.value === field.selectedAnswer
          );
          fieldValueAnswer = !!field.selectedAnswer && fieldValue?.label;
        }
        csvAnswer[field.uniqueId] = fieldValueAnswer;
      } else {
        csvAnswer[field.uniqueId] = field.selectedAnswer;
      }
    });
  });


 
  const handleGeneratePdf = async () => {
    const content = pdfRef.current;
    console.log("content", content);
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "pt",
      format: "a4",
    });

    const opt = {
      margin: [5, 0, 10, 0],
      filename: `output.pdf`,
      enableLinks: false,
      pagebreak: {
        mode: "",
        before: ".break-before",
        after: ".break-after",
        avoid: ".break-avoid",
      },
      image: { type: "jpeg", quality: 1 },
      html2canvas: {
        allowTaint: true,
        dpi: 300,
        letterRendering: true,
        logging: false,
        scale: 2,
        scrollX: 0,
        scrollY: 0,
      },
      jsPDF: { doc },
    };

    const data = await html2pdf()
      .from(content)
      .set(opt)
      .toPdf()
      .get("pdf")
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();

        for (let i = 1; i < totalPages + 1; i++) {
          pdf.setPage(i);
          const headerHtml = `
          <div style="text-align: center; margin-bottom: 10px;">
            <img src="${logo}" alt="Agency Logo" style="width: 100px; height: auto;">
          </div>
        `;
          console.log("Logo Source:", logo);
          console.log("Header HTML:", headerHtml);
          pdf.addImage(logo, 175, 5, 30, 20);
          pdf.setFontSize(8);
          pdf.text(
            `${i}/${totalPages}`,
            pdf.internal.pageSize.getWidth() - 10,
            pdf.internal.pageSize.getHeight() - 5
          );
        }
      })
      // .output("datauristring");
      .output("blob");
    const blobUrl = URL.createObjectURL(data);

    // Now 'blobUrl' contains the Blob URL, and you can use it for download or other purposes
    console.log(blobUrl);
    setDocumentUrl(blobUrl);
    // For example, open the Blob URL in a new tab
    // window.open(blobUrl, "_blank");
    // let strValue = data.split(",")[1];
    // console.log(strValue, "str");
    // const binaryData = atob(strValue);

    // // Convert binary data to Blob
    // const arrayBuffer = new ArrayBuffer(binaryData.length);
    // const uint8Array = new Uint8Array(arrayBuffer);

    // for (let i = 0; i < binaryData.length; i++) {
    //   uint8Array[i] = binaryData.charCodeAt(i);
    // }

    // const blob = new Blob([arrayBuffer], { type: "application/pdf" });

    // // Now 'blob' contains the PDF data, and you can use it as needed
    // console.log(blob);
  };
  let dogLicenseDetails = async (e) => {
    setloading(true);
    const config = {
      method: "GET",
      url: DOG_LICENSE_DETAILS,
      // headers: authCustomerHeader(),
      params: {
        dogLicenseId: dogLicenseId,
      },
    };
    try {
      const response = await API(config);
      const { status, data } = response.data;
      if (status === "Success") {
        setlicenseDetails(data);
        handleGeneratePdf();
        // setReupload({
        //   validFromDate: data.validFromDate,
        //   validToDate: data.validToDate,
        //   dogLicenseNumber: data.dogLicenseNumber,
        // });
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        CustomAlertMessage(data.message, "error", enqueueSnackbar);
      }
    } finally {
      setloading(false);
    }
  };

  useEffect(() => {
    if (dogLicenseId && currentStep === "4" && !moreflag) {
      dogLicenseDetails();
    }
  }, [dogLicenseId, currentStep, moreflag]);

  let Refund = async (reson) => {
    setloading(true);
    const config = {
      method: "POST",
      url: REFUND_PAYMENT,
      data: {
        paymentDetailId: paymaentid.paymentDetailId,
        refundReason: reson,
      },
      // headers: authHeader(),
    };
    try {
      // setDeleverSpinner(true);
      const response = await API(config);
      const { status, message } = response.data;

      if (status === "Success") {
        CustomAlertMessage(message, "success", enqueueSnackbar);
        dogLicenseDetails();
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        CustomAlertMessage(data.message, "error", enqueueSnackbar);
      }
    } finally {
      setloading(false);
      // setDeleverSpinner(false);
    }
  };

  // let UpdateDate = () => {
  //   if (DeleteAgency) {
  //     return;
  //   }
  //   setreqNu(false);
  //   setModal(true);
  // };

  let ReuploadForm = () => {
    if (DeleteAgency) {
      return;
    }
    console.log("EDIT");
    setisEditable(false);
  };

  let sucesscallback = async () => {
    dogLicenseDetails();
    setisEditable(true);
    const conf = {
      method: "PUT",
      url: UPDATE_LICENSE_STATUS,
      data: {
        dogLicenseId: dogLicenseId,
        licenseStatus: "Payment Completed",
        licensePlanId: licensePlanId,
      },
    };
    try {
      const response1 = await API(conf);
      console.log("sucess",response1);
    } catch (error) {
      console.error(error);
    }
  };

  const Cancellicense = async () => {
    if (DeleteAgency) {
      return;
    }
     Swal.fire({
      title: "Reason for Cancel",
      input: "text",
      showCancelButton: true,
      allowOutsideClick: false,
      inputPlaceholder: "Enter Reason for Cancel ",
      inputValidator: (value) => {
        if (!value) {
          return "Please enter the reason for Cancel";
        } else {
          Refund(value);
        }
      },
    });
  };

 
  useEffect(() => {
    if (currentStep === "4") {
      // Your script here
      // handleGeneratePdf();
    }
  }, [currentStep]);
  return (
    <div id="" ref={pdfRef}>
      <div>
        {/* <HeaderLogo /> */}
        {loading && <CustomPageLoading />}

        <Container fluid="lg">
          <div>
            <div className="top-btn"></div>
          </div>

          <Card body className="mt-4 license-details">
            <div className="agency-license-view">
              <Row>
                <Col md={{ size: "auto", offset: 0 }}>
                  <h4>{planName}</h4>
                </Col>
              </Row>
            </div>

            <h5>License Details</h5>

            {/* <Row> */}
            {!isEditable ? (
              <ReuploadFormValue
                setisEditable={setisEditable}
                sucesscallback={sucesscallback}
                categoryData={categoryData}
                dogId={dogId}
                document={document}
                Answer={Answer}
              />
            ) : (
              <AgencyPreviewform
                isEditable={isEditable}
                document={document}
                Answer={Answer}
              />
            )}
            {/* </Row> */}
            {!DeleteAgency
              ? isEditable && (
                  <div className="centerFlexRow">
                    {licenseStatus === "Rejected" && (
                      <>
                        {" "}
                        <Button color="primary" onClick={ReuploadForm}>
                          Resubmit
                        </Button>
                        <span style={{ margin: "0 2px" }}></span>
                        <Button color="danger" onClick={Cancellicense}>
                          Cancel Order
                        </Button>
                      </>
                    )}
                  </div>
                )
              : ""}
          </Card>

          <Card body className="mt-5">
            <h5 className="mb-4">Plan Details</h5>

            <Row className="plan-list">
              {licensePlanData.map((li) => (
                <Col md="6" xl="4">
                  <div className="box">
                    <h4>{li.planName}</h4>
                    <h1>
                      <strong>$</strong>
                      {parseFloat(li.planAmount).toFixed(2)}
                    </h1>
                    <span>
                      {li.isLifeTimePlan && "Life Time Plan"}

                      {!!li.validTo && (
                        <>
                          {" "}
                          <span>Till Date</span>{" "}
                          {moment(li.validTo).format("MM-DD-YYYY")}
                        </>
                      )}
                      {!!li.planDuration && li.planDuration + "/ year"}
                    </span>
                    <p>{li.planDescription}</p>

                    <ul>
                      {li.isParkLicense ? (
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.011"
                            height="17.011"
                            viewBox="0 0 17.011 17.011"
                          >
                            <path
                              id="Icon_material-check-box"
                              data-name="Icon material-check-box"
                              d="M19.621,4.5H6.39A1.89,1.89,0,0,0,4.5,6.39V19.621a1.89,1.89,0,0,0,1.89,1.89H19.621a1.89,1.89,0,0,0,1.89-1.89V6.39A1.89,1.89,0,0,0,19.621,4.5ZM11.115,17.731,6.39,13.005l1.333-1.333,3.393,3.383,7.173-7.173,1.333,1.342Z"
                              transform="translate(-4.5 -4.5)"
                              fill="#fff"
                            />
                          </svg>
                          Park License
                        </li>
                      ) : (
                        ""
                      )}

                      {li.isKennelLicense && (
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.011"
                            height="17.011"
                            viewBox="0 0 17.011 17.011"
                          >
                            <path
                              id="Icon_material-check-box"
                              data-name="Icon material-check-box"
                              d="M19.621,4.5H6.39A1.89,1.89,0,0,0,4.5,6.39V19.621a1.89,1.89,0,0,0,1.89,1.89H19.621a1.89,1.89,0,0,0,1.89-1.89V6.39A1.89,1.89,0,0,0,19.621,4.5ZM11.115,17.731,6.39,13.005l1.333-1.333,3.393,3.383,7.173-7.173,1.333,1.342Z"
                              transform="translate(-4.5 -4.5)"
                              fill="#fff"
                            />
                          </svg>
                          Kennel License
                        </li>
                      )}

                      {li.isDogLicense && (
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.011"
                            height="17.011"
                            viewBox="0 0 17.011 17.011"
                          >
                            <path
                              id="Icon_material-check-box"
                              data-name="Icon material-check-box"
                              d="M19.621,4.5H6.39A1.89,1.89,0,0,0,4.5,6.39V19.621a1.89,1.89,0,0,0,1.89,1.89H19.621a1.89,1.89,0,0,0,1.89-1.89V6.39A1.89,1.89,0,0,0,19.621,4.5ZM11.115,17.731,6.39,13.005l1.333-1.333,3.393,3.383,7.173-7.173,1.333,1.342Z"
                              transform="translate(-4.5 -4.5)"
                              fill="#fff"
                            />
                          </svg>
                          Dog License
                        </li>
                      )}
                    </ul>
                  </div>
                </Col>
              ))}
            </Row>
          </Card>
        </Container>
      </div>
    </div>
  );
}
